// Imports
// ------
import React from 'react';
import Button from '@global/buttons/pink-button';
import styled, { css } from 'styled-components';
import { Div, H3, P } from '@reuse';
import { graphql, StaticQuery } from 'gatsby';

// Styles
// ------
const Jacket = styled(Div)`
    position: fixed;
    z-index: 69;
    bottom: 2.4rem;
    left: -100%;

    width: 36rem;
    padding: 2.4rem;

    background: white;
    border-radius: 1.2rem;
    transition: all 1s ${props => props.theme.bezzy};

    ${props => props.isActive && css`
        left: 2.4rem;
    `}
`;

const darkText = css`
    ${props => props.dark && css` color: ${props.theme.bc3}; `}
`;


const Title = styled(H3)`
    color: ${props => props.theme.bc5};
    margin-bottom: 1.2rem;
`;

const Text = styled(P)`
    ${darkText}
    margin-bottom: 1.2rem;
`;

const StyledButton = styled(Button)`
    &:hover {
        p {
            color: ${props => props.theme.bc2};
        }

        svg {
            fill: ${props => props.theme.bc2};
            stroke: ${props => props.theme.bc2};
        }
    }
`;

const Close = styled.svg`
    position: absolute;
    top: 2.4rem; right: 2.4rem;
    
    width: 2.4rem;
    height: 2.4rem;
    fill: ${props => props.theme.bc1};

    opacity: 0.25;
    transition: all .25s ease-in-out;

    &:hover { opacity: 1; }
`;

// Component
// ------
class Popup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            popup: false
        }
    }
    
    togglePopup = () => {
        this.setState({ popup: !this.state.popup })
    }
    

    render() {
        const title = this.props.data.datoCmsPopup.title;
        const text = this.props.data.datoCmsPopup.text;

        return (
            <Jacket isActive={this.state.popup}>
                <Title>{title}</Title>
                <Text dark>{text}</Text>
                <StyledButton to="/contact/">Get in touch</StyledButton>

                <Close width="12" height="12" viewBox="0 0 16 16" onClick={this.togglePopup}>
                    <path d="M14.7,1.3c-0.4-0.4-1-0.4-1.4,0L8,6.6L2.7,1.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4L6.6,8l-5.3,5.3 c-0.4,0.4-0.4,1,0,1.4C1.5,14.9,1.7,15,2,15s0.5-0.1,0.7-0.3L8,9.4l5.3,5.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L9.4,8l5.3-5.3C15.1,2.3,15.1,1.7,14.7,1.3z"/>
                </Close>
            </Jacket>
        )
    }
    
    componentDidMount() {
        const time = Math.floor(Math.random() * 60000) + 10000;

        this.timer = setTimeout( () => {
            this.togglePopup();
        }, time);
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }
}

export default () => (
    <StaticQuery
        query={graphql`
            query {
                datoCmsPopup {
                    title
                    text
                }
            }
        `}

        render={(data) => {
            return <Popup data={data} />
        }}
    />
);